import React, { useEffect } from 'react'
import styled from 'styled-components'

const CardWrapper = styled.div`
    display: flex;
    width: 100%;
    margin-bottom: 1rem;

    border-bottom:1px solid #5A5A5A;
`
const Box = styled.div`
`
const Row = styled.div`

    display:flex;
    justify-content: space-between;

    .remove_space{
        height: 15px;
    }


`
const BoxText = styled.div`
    margin-bottom: 1.2rem;
    height:2rem;
    min-width: 230px;

    p{
        font-size: 0.9rem;
        font-family: "Poppins";
        font-weight: 500;
        height: 0.2rem;
    }

    .textPrimary{
        max-width: 450px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        font-size: 1rem;
        height: auto;
        font-family: "Poppins";
        font-weight: 600;
    }


`
const Line = styled.div`

    display:flex;
    align-items: center;
    
    div{
        margin-right: 3.9rem;
    }

`
const HeaderCard = styled.div`
    display:flex;
    justify-content: space-between;

`


const CardDataAddressTiny = ({ address, client, complement, number, numberItens, cpf, data }) => {


    useEffect(() => {

        console.log(data)

    }, [data])

    return (
        <CardWrapper>
            <Box>
                <BoxText>
                    <p>CEP</p>
                    <p className='textPrimary'>{data?.zipCode}</p>
                </BoxText>
                <BoxText>
                    <p>Endereço</p>
                    <p className='textPrimary'>{address}</p>
                </BoxText>
                <BoxText>
                    <p>Bairro</p>
                    <p className='textPrimary'></p>
                </BoxText>


            </Box>
            <Box>
                <BoxText>
                    <p>Cidade</p>
                    <p className='textPrimary'>{data?.city}</p>
                </BoxText>
                <BoxText>
                    <p>Número</p>
                    <p className='textPrimary'>{data?.number}</p>
                </BoxText>
                <BoxText>
                    <p>Tipo de Pessoa</p>
                    <p className='textPrimary'>Física</p>
                </BoxText>


            </Box>
            <Box>
                <BoxText>
                    <p>UF</p>
                    <p className='textPrimary'>{data?.state}</p>
                </BoxText>
                <BoxText>
                    <p>CPF</p>
                    <p className='textPrimary'>{cpf}</p>
                </BoxText>
                <BoxText>
                    <p>Complemento</p>
                    <p className='textPrimary'>{data?.complement ? data?.complement : "N/A"}</p>
                </BoxText>


            </Box>

        </CardWrapper>
    )
}

export default CardDataAddressTiny